import { render, staticRenderFns } from "./BecomeClient.vue?vue&type=template&id=01b59182&scoped=true&"
import script from "./BecomeClient.vue?vue&type=script&lang=ts&"
export * from "./BecomeClient.vue?vue&type=script&lang=ts&"
import style0 from "./BecomeClient.vue?vue&type=style&index=0&id=01b59182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b59182",
  null
  
)

export default component.exports